import React, { Component } from 'react'
import { connect } from 'react-redux'
import './App.css'
import { Route, Redirect, withRouter } from 'react-router-dom'

import { appStart } from 'state/actions'
import { getLoggedUser } from 'lib/reader'

import LogInContainer from 'containers/LogIn'
import HomeContainer from 'containers/Home'

class App extends Component {

  // Signal APP_START !
  UNSAFE_componentWillMount() {
    const { appStart } = this.props
    appStart()
  }

  render() {
    const { loggedUser } = this.props
    return (
      <div className="App">

        <Route exact path="/login" component={LogInContainer} />
        <Route path="/" render={() => (loggedUser ? <HomeContainer /> : <Redirect to="/login" />) }/>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  loggedUser: getLoggedUser(state),
})

export default withRouter(connect(
  mapStateToProps,
  { appStart }
)(App))



// WEBPACK FOOTER //
// ./src/App.js